'use client';

import { useEffect } from 'react';
import {
  AuthenticatedTemplate,
  MsalProvider,
  UnauthenticatedTemplate,
} from '@azure/msal-react';
import { msalInstance, MsalHelper } from './helpers';
import { NotAuthenticated } from './components';

type Props = {
  children: React.ReactNode;
};

export default function MyMsalProvider({ children }: Readonly<Props>) {
  useEffect(() => {
    MsalHelper.initializeMsal();
  }, []);

  return (
    <MsalProvider instance={msalInstance}>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <NotAuthenticated />
      </UnauthenticatedTemplate>
    </MsalProvider>
  );
}
